import { render, staticRenderFns } from "./Codes.vue?vue&type=template&id=6a63d106&"
import script from "./Codes.vue?vue&type=script&lang=js&"
export * from "./Codes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports